import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import D3Transition from './D3-sample-cart-transition';
import D3Row from './D3-sample-cart-row';

import { updateSampleCart, removePOST} from '../../../../store/actions/sampleCart';

class Table extends Component {
	state = {
		products: [],
	}

	timeout = 500;

	componentDidMount() {
		const { products } = this.props;
		const activeProducts = products.map((product) => {
			return {
				...product,
				active: true,
			};
		});
		this.setState({ products: [...activeProducts] });
	}

	componentDidUpdate() {
		const { products } = this.state;
		const { dispatch } = this.props;
		const filterRemoved = products.filter((product) => { return product.active; });
		const updatedProducts = filterRemoved.map((product) => {
			const obj = { ...product };
			delete obj.active;
			return obj;
		});

		dispatch(updateSampleCart(updatedProducts));
	}

	removeProduct = (event, id) => {
		const { products } = this.state;
		const { dispatch } = this.props;
		const disableProduct = products.map((product) => {
			return product._id !== id ? { ...product } : { ...product, active: false };
		});

		event.preventDefault();
		this.setState({ products: [...disableProduct] });
		dispatch(removePOST(id));
	}

	resetElementHeight = (element) => {
		element.style.height = '';
	}

	updateProducts = (id, key, option) => {
		const { products } = this.state;
		const updated = products.map((product) => {
			let newProduct = product;

			if (product._id === id) {
				newProduct = {
					...product,
					[key]: option,
				};
			}

			return newProduct;
		});

		this.setState({ products: [...updated] });
	}

	checkIfCartIsEmpty = () => {
		const { emptyCart } = this.props;
		const { products } = this.state;
		const isEmpty = products.filter((product) => { return product.active; });
		if (!isEmpty.length) emptyCart();
	}

	render() {
		const { products } = this.state;
		const { labels } = this.props;
		const renderRows = products.map((product, index) => {
			return (
				<D3Transition
					timeout={this.timeout}
					key={`D3__product-${product._id}`}
					delay={index}
					active={product.active}
					callbacks={{
						resetHeight: this.resetElementHeight,
						checkEmptyCart: this.checkIfCartIsEmpty,
					}}
				>
					<D3Row product={product} callbacks={{ remove: this.removeProduct, update: this.updateProducts }} labels={labels} />
				</D3Transition>
			);
		});

		return (
			<div className="D3-sample-cart__table">
				<div className="D3-sample-cart__table-row D3-sample-cart__table-head">
					<div className="D3-sample-cart__table-row-container">
						<div className="D3-sample-cart__table-cell">{labels.product}</div>
						<div className="D3-sample-cart__table-cell">{labels.size}</div>
						<div className="D3-sample-cart__table-cell">{labels.quantity}</div>
						<div className="D3-sample-cart__table-cell">{labels.type}</div>
						<div className="D3-sample-cart__table-cell">&nbsp;</div>
					</div>
				</div>
				<TransitionGroup className="D3-sample-cart__animated-group">
					{ renderRows }
				</TransitionGroup>
			</div>
		);
	}
}

Table.propTypes = {
	products: PropTypes.arrayOf(PropTypes.shape({})),
	dispatch: PropTypes.func.isRequired,
	emptyCart: PropTypes.func,
	labels: PropTypes.shape({}),
};

Table.defaultProps = {
	products: [],
	emptyCart: () => {},
	labels: {
		product: 'Products',
		size: 'Size',
		quantity: 'Qty',
		type: 'Type',
		removeButton: 'Remove',
	},
};

export default connect()(Table);
